import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Alert,
} from "@mui/material";

export default function ScopeTable5500({ open, onClose, functionType, subFunction }) {
  const [scopeData, setScopeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchScopeData = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const params = new URLSearchParams();
      if (functionType) params.append("function", functionType);
      if (subFunction) params.append("subFunction", subFunction);

      const response = await fetch(
        //`http://localhost:8080/api/calculator/query5500?${params.toString()}`
        `/api/calculator/query5500?${params.toString()}`
      );
      if (!response.ok) throw new Error("Failed to fetch scope data");

      const data = await response.json();
      setScopeData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [functionType, subFunction]);

  useEffect(() => {
    if (open) {
      fetchScopeData();
    }
  }, [open, fetchScopeData]);

  const headers = scopeData.length > 0 ? Object.keys(scopeData[0]) : [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>ISO 17025 Accreditation Scope</DialogTitle>
      <DialogContent>
        {loading && <CircularProgress />}
        {error && <Alert severity="error">{error}</Alert>}

        {!loading && !error && scopeData.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableCell key={header}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {scopeData.map((row, index) => (
                <TableRow key={index}>
                  {headers.map((header) => (
                    <TableCell key={header}>{row[header]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}

        {!loading && !error && scopeData.length === 0 && (
          <Alert severity="info">No data found.</Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}